<template>
  <div
    :class="[
      'expandable-description',
      { 'is-expandable': isExpandable, 'is-expanded': isExpanded, 'is-mobile': isMobile },
    ]"
    @click="isExpanded = !isExpanded"
    ref="containerEl"
  >
    <div class="truncation" ref="truncationEl">
      <slot />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { isMobile } from '@/core/helpers/ui.helper';
import { onMounted, ref } from 'vue';

const containerEl = ref<HTMLDivElement>();
const truncationEl = ref<HTMLDivElement>();
const isExpandable = ref(false);
const isExpanded = ref(false);

onMounted(() => {
  if (!truncationEl.value) return;

  if (truncationEl.value.scrollHeight > truncationEl.value.clientHeight) {
    isExpandable.value = true;
  }
});
</script>

<style lang="scss" scoped>
@use '@/ui/css/mixins' as *;
@use '@/ui/css/partial';

.expandable-description {
  width: 100%;
  padding: calc(var(--spacing-l) - 2px) var(--spacing-h) var(--spacing-l) var(--spacing-h);
  border-radius: var(--radius-small);
  border: 1px solid var(--color-white-10);
  color: var(--color-white-50);
  font-style: italic;
  font-weight: 200;
  letter-spacing: 0.05em;

  transition: background-color var(--transition);
}

.expandable-description.is-mobile {
  padding: calc(var(--spacing-l) - 2px) var(--spacing-l) var(--spacing-l) var(--spacing-l);
  background-color: var(--color-dark-600);
  border-radius: 0;
  border-left: none;
  border-right: none;
  border-color: var(--color-white-5);
}
@include hover-capable {
  .expandable-description.is-expandable:hover {
    cursor: pointer;
    background-color: var(--color-dark-700);
  }
}

.expandable-description.is-expanded {
  .truncation {
    display: block;
  }
}

.truncation {
  width: 100%;
  line-height: 1.5;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  line-clamp: 3;
  text-overflow: ellipsis;
  overflow: hidden;
  text-wrap-style: balance;
  white-space: pre-line;
}
</style>
